import type { Reward } from './config';


export const REFERRAL_WELCOME_REWARD = {
  anima: 10_000,
  boosters: { premium: 10 },
} as const satisfies Reward;


const REFERRAL_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
export const REFERRAL_CODE_LENGTH = 8;

export const REFERRAL_REDEEM_WINDOW_DAYS = 31;

export const REFERRAL_CODE_PATTERN = /^[A-Z0-9]{6,12}$/;

export function normalizeReferralCode(value: string): string {
  return value.trim().toUpperCase().replace(/[\s-]+/g, '');
}

export function generateReferralCode(
  random: (bytes: Uint8Array<ArrayBuffer>) => Uint8Array = (bytes) => crypto.getRandomValues(bytes),
): string {
  const bytes = random(new Uint8Array(REFERRAL_CODE_LENGTH));
  let code = '';
  for (const byte of bytes) code += REFERRAL_ALPHABET[byte % REFERRAL_ALPHABET.length];
  return code;
}
